import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-farmaco',
  templateUrl: './farmaco.page.html',
  styleUrls: ['./farmaco.page.scss']
})
export class FarmacoPage implements OnInit {
  constructor(public modalController: ModalController) {}

  ngOnInit() {}

  async closeModal() {
    await this.modalController.dismiss()
  }
}
